import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Typography,
  Button,
  CircularProgress,
} from '@mui/material';

export default function QuickRegisterDialog({ open, onClose, onSubmit, loading }) {
  const [newPlayerData, setNewPlayerData] = useState({ apellido: '', nombres: '', documento: '' });
  const [dialogErrors, setDialogErrors] = useState({});

  const handleDialogChange = (e) => {
    const { name, value } = e.target;
    setNewPlayerData((prev) => ({ ...prev, [name]: value }));
    if (dialogErrors[name]) {
      setDialogErrors((prev) => ({ ...prev, [name]: null }));
    }
  };

  const validateDialogForm = () => {
    const tempErrors = {};
    if (!newPlayerData.apellido.trim()) {
      tempErrors.apellido = 'El apellido es obligatorio';
    }
    if (!newPlayerData.nombres.trim()) {
      tempErrors.nombres = 'El nombre es obligatorio';
    }
    setDialogErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const handleDialogSubmit = () => {
    if (!validateDialogForm()) return;
    onSubmit(newPlayerData, () => {
      setNewPlayerData({ apellido: '', nombres: '', documento: '' });
    });
  };

  const handleClose = () => {
    setNewPlayerData({ apellido: '', nombres: '', documento: '' });
    setDialogErrors({});
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      PaperProps={{
        sx: {
          borderRadius: 0,
          background: '#1e293b',
          backgroundImage: 'none',
          border: '1px solid rgba(255, 255, 255, 0.12)',
          color: '#cbd5e1',
          width: '100%',
          maxWidth: '450px',
        },
      }}
    >
      <DialogTitle sx={{ borderBottom: '1px solid rgba(255, 255, 255, 0.08)', pb: 1.5, fontWeight: 600 }}>
        Registrar Nuevo Jugador
      </DialogTitle>
      <DialogContent sx={{ mt: 2, display: 'flex', flexDirection: 'column', gap: 2.5 }}>
        <Typography variant="body2" sx={{ color: '#94a3b8' }}>
          El jugador se creará en el sistema y se inscribirá automáticamente en este torneo.
        </Typography>

        <TextField
          required
          fullWidth
          label="Apellido"
          name="apellido"
          value={newPlayerData.apellido}
          onChange={handleDialogChange}
          error={!!dialogErrors.apellido}
          helperText={dialogErrors.apellido}
          InputLabelProps={{ style: { color: '#94a3b8' } }}
          inputProps={{ style: { color: '#cbd5e1' } }}
          sx={{
            '& .MuiOutlinedInput-root': {
              borderRadius: 0,
              '& fieldset': { borderColor: 'rgba(255, 255, 255, 0.15)', borderRadius: 0 },
              '&:hover fieldset': { borderColor: '#3a6eb6' },
              '&.Mui-focused fieldset': { borderColor: '#3a6eb6' },
            },
          }}
        />

        <TextField
          required
          fullWidth
          label="Nombres"
          name="nombres"
          value={newPlayerData.nombres}
          onChange={handleDialogChange}
          error={!!dialogErrors.nombres}
          helperText={dialogErrors.nombres}
          InputLabelProps={{ style: { color: '#94a3b8' } }}
          inputProps={{ style: { color: '#cbd5e1' } }}
          sx={{
            '& .MuiOutlinedInput-root': {
              borderRadius: 0,
              '& fieldset': { borderColor: 'rgba(255, 255, 255, 0.15)', borderRadius: 0 },
              '&:hover fieldset': { borderColor: '#3a6eb6' },
              '&.Mui-focused fieldset': { borderColor: '#3a6eb6' },
            },
          }}
        />

        <TextField
          fullWidth
          label="DNI / Documento"
          name="documento"
          value={newPlayerData.documento}
          onChange={handleDialogChange}
          error={!!dialogErrors.documento}
          helperText={dialogErrors.documento}
          InputLabelProps={{ style: { color: '#94a3b8' } }}
          inputProps={{ style: { color: '#cbd5e1' } }}
          sx={{
            '& .MuiOutlinedInput-root': {
              borderRadius: 0,
              '& fieldset': { borderColor: 'rgba(255, 255, 255, 0.15)', borderRadius: 0 },
              '&:hover fieldset': { borderColor: '#3a6eb6' },
              '&.Mui-focused fieldset': { borderColor: '#3a6eb6' },
            },
          }}
        />
      </DialogContent>
      <DialogActions sx={{ p: 3, borderTop: '1px solid rgba(255, 255, 255, 0.08)', gap: 1.5 }}>
        <Button
          variant="outlined"
          onClick={handleClose}
          sx={{
            color: '#94a3b8',
            borderColor: 'rgba(255, 255, 255, 0.15)',
            borderRadius: 0,
            '&:hover': {
              borderColor: '#cbd5e1',
              background: 'rgba(255, 255, 255, 0.05)',
            },
          }}
        >
          Cancelar
        </Button>
        <Button
          variant="contained"
          onClick={handleDialogSubmit}
          disabled={loading}
          sx={{
            background: '#3a6eb6',
            borderRadius: 0,
            '&:hover': { background: '#2a5793' },
          }}
        >
          {loading ? <CircularProgress size={20} color="inherit" /> : 'Registrar e Inscribir'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
